"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DialogAlert = _interopRequireDefault(require("@/ui/components/DialogAlert"));
var _ButtonActionsHeader = _interopRequireDefault(require("./components/ButtonActionsHeader"));
var _CardDescriptionPlan = _interopRequireDefault(require("./components/CardDescriptionPlan"));
var _ContentCardsPlans = _interopRequireDefault(require("./components/ContentCardsPlans"));
var _ContentPaymentOptions = _interopRequireDefault(require("./components/ContentPaymentOptions"));
var _ModalCredCard = _interopRequireDefault(require("./components/ModalCredCard"));
var _ModalTicket = _interopRequireDefault(require("./components/ModalTicket"));
var _ContentDetailPaymentsList = _interopRequireDefault(require("./components/ContentDetailPaymentsList"));
var _vuex = require("vuex");
var _constants = require("@/config/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'PaymentFarmsDetails',
  components: {
    ButtonActionsHeader: _ButtonActionsHeader.default,
    CardDescriptionPlan: _CardDescriptionPlan.default,
    ContentCardsPlans: _ContentCardsPlans.default,
    ContentPaymentOptions: _ContentPaymentOptions.default,
    ContentDetailPaymentsList: _ContentDetailPaymentsList.default
  },
  data: function data() {
    return {
      TYPES_PAYMENTS: _constants.TYPES_PAYMENTS,
      idSubscription: null,
      typePayment: {},
      formOfPayment: null,
      modeViewPayment: true,
      renovationChecked: false,
      errorNumber: false,
      plansPayments: [],
      provider: '',
      securityCodeValid: '',
      dataInvoices: [],
      payment: {},
      transactionsRecurrents: {},
      discount: {},
      dialogChange: null,
      changeMethodPayment: false,
      showUpdateSignature: false,
      totalArea: 0,
      itemPayment: {}
    };
  },
  computed: {
    errorForm: function errorForm() {
      return this.form.cardNumber.length < 16 || this.errorNumber;
    },
    farm: function farm() {
      if (this.itemPayment.farm) return this.itemPayment.farm;
      return {};
    },
    plan: function plan() {
      if (this.itemPayment.plan) return this.itemPayment.plan;
      return {};
    },
    paymentsMade: function paymentsMade() {
      var invoices = this.dataInvoices;
      return invoices || [];
    },
    verifyArea: function verifyArea() {
      var totalArea = this.itemPayment.totalArea;
      var totalAreaHectare = this.$options.filters.convertAreaNoUnit(totalArea);
      var total = Number(totalAreaHectare);
      var totalPlan = Number(this.plan.totalSize) || 0;
      var amount = Number(this.plan.amount) || 0;
      return total === totalPlan && amount > 0;
    },
    lastPayment: function lastPayment() {
      return this.paymentsMade.at(-1) || {};
    },
    selectedPlan: function selectedPlan() {
      if (this.typePayment.id) return this.typePayment;
      return this.plan;
    }
  },
  watch: {
    form: {
      handler: function handler(val) {
        if (!val.cardNumber.length) {
          this.provider = '';
          this.securityCodeValid = '';
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.idSubscription = id;
    this.getSubscriptionDetail();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['resetFarm', 'fetchSubscriptionDetail', 'fetchPaymentInvoices', 'consultCreditCardBin', 'subscriptionPayment', 'changePaymentMethod', 'fetchRecurrentPayment', 'consultTransationsOrderId', 'cancelPlan', 'fetchFarmPayment', 'updateSignaturePlan', 'generateNewTicketInvoice', 'fetchSizeFarm'])), {}, {
    goToBack: function goToBack() {
      this.resetFarm();
      this.$router.push({
        path: "/payment-list-farms"
      });
    },
    getSubscriptionDetail: function () {
      var _getSubscriptionDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchSubscriptionDetail(this.idSubscription);
            case 1:
              data = _context.v;
              if (!data) {
                _context.n = 3;
                break;
              }
              this.formOfPayment = '';
              this.modeViewPayment = false;
              this.typePayment = {};
              this.itemPayment = data;
              if (!(this.itemPayment.amount && this.itemPayment.amount > 0)) {
                _context.n = 3;
                break;
              }
              this.modeViewPayment = false;
              this.getTotalAreaFarm();
              _context.n = 2;
              return this.fetchPaymentInvoices(this.idSubscription);
            case 2:
              this.dataInvoices = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getSubscriptionDetail() {
        return _getSubscriptionDetail.apply(this, arguments);
      }
      return getSubscriptionDetail;
    }(),
    updateSignature: function () {
      var _updateSignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getTotalAreaFarm();
            case 1:
              this.showUpdateSignature = !this.showUpdateSignature;
              // const dataSend = {
              //   farmId: this.itemPayment.id,
              //   planId: this.itemPayment.paymentData.id
              // }
              // const res = await this.updateSignaturePlan(dataSend)
              // if (res) this.getFarmDetailPayment()
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function updateSignature() {
        return _updateSignature.apply(this, arguments);
      }
      return updateSignature;
    }(),
    getTotalAreaFarm: function () {
      var _getTotalAreaFarm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.fetchSizeFarm(this.itemPayment.farmId);
            case 1:
              data = _context3.v;
              if (data) {
                this.totalArea = data;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getTotalAreaFarm() {
        return _getTotalAreaFarm.apply(this, arguments);
      }
      return getTotalAreaFarm;
    }(),
    calculateValuePerHectare: function calculateValuePerHectare(plan) {
      var totalArea = this.totalArea.area;
      var totalAreaHectare = this.$options.filters.convertAreaNoUnit(totalArea);
      var ammount = (plan.valuePerHectare * totalAreaHectare).toFixed(2);
      return ammount;
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$v.form.$touch();
              if (!this.$v.form.$error) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.cardPayment(this.form);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    submitFormTicket: function () {
      var _submitFormTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.$v.formTicket.$touch();
              if (!this.$v.formTicket.$error) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              this.ticketPayment(this.formTicket);
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function submitFormTicket() {
        return _submitFormTicket.apply(this, arguments);
      }
      return submitFormTicket;
    }(),
    resetFormCard: function resetFormCard(state) {
      this.form = {
        cardNumber: '',
        holder: '',
        expirationDate: '',
        securityCode: ''
      };
      this.$v.form.$reset();
    },
    resetFormTicket: function resetFormTicket(state) {
      this.formTicket = {
        name: '',
        identity: '',
        street: '',
        number: '',
        complement: '',
        zip: '',
        city: '',
        state: '',
        country: 'BRA',
        district: ''
      };
      this.formOfPayment = '';
      this.$v.formTicket.$reset();
    },
    consultBin: function () {
      var _consultBin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(number) {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(number.length < 6)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _context6.n = 2;
              return this.consultCreditCardBin(number.substring(0, 6));
            case 2:
              data = _context6.v;
              if (data) {
                _context6.n = 3;
                break;
              }
              this.errorNumber = true;
              return _context6.a(2);
            case 3:
              this.errorNumber = false;
              this.provider = data.Provider;
              this.securityCodeValid = data.IssuerCode;
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function consultBin(_x) {
        return _consultBin.apply(this, arguments);
      }
      return consultBin;
    }(),
    selectPaymentPlan: function selectPaymentPlan(plan) {
      this.typePayment = plan;
      this.formOfPayment = null;
    },
    // async getRecurrentPayment () {
    //   const recurrentId = this.dataInvoice.transactionId
    //   const data = await this.fetchRecurrentPayment(recurrentId)
    //   if (data) {
    //     this.payment = data.RecurrentPayment
    //     this.consultTransactions()
    //   }
    // },
    // async consultTransactions () {
    //   const orderId = this.dataInvoice.orderId
    //   const data = await this.consultTransationsOrderId(orderId)
    //   if (data) {
    //     this.transactionsRecurrents = data
    //   }
    // },
    confirmChangePaymentMethod: function confirmChangePaymentMethod() {
      var self = this;
      self.dialogChange = self.$buefy.modal.open({
        parent: self,
        component: _DialogAlert.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          title: 'Alterar o método de pagamento',
          message: 'Deseja realmente alterar o método de pagamento utilizado?',
          confirmText: 'Sim',
          onConfirm: self.changePayment,
          product: self.itemPayment,
          type: 'is-danger'
        }
      });
    },
    confirmCancel: function confirmCancel() {
      var self = this;
      self.dialogChange = self.$buefy.modal.open({
        parent: self,
        component: _DialogAlert.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          title: 'Cancelamento de Plano',
          message: 'Deseja realmente cancelar sua assinatura e perder todos os benefícios que a Fiboo pode proporcionar?',
          confirmText: 'Sim',
          onConfirm: self.cancelPlanMethod,
          product: self.itemPayment,
          type: 'is-danger'
        }
      });
    },
    changePayment: function () {
      var _changePayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(item) {
        var type;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.changeMethodPayment = true;
              this.typePayment = item.plan;
              type = item.typePayment.type;
              this.formOfPayment = type === this.TYPES_PAYMENTS.TICKET ? this.TYPES_PAYMENTS.CREDIT_CARD : this.TYPES_PAYMENTS.TICKET;
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function changePayment(_x2) {
        return _changePayment.apply(this, arguments);
      }
      return changePayment;
    }(),
    cardPayment: function () {
      var _cardPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(form) {
        var dataSend, fun, data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              dataSend = {
                planId: this.typePayment.id,
                farmId: this.itemPayment.id,
                paymentMethod: {
                  method: this.formOfPayment,
                  creditCard: {
                    cardNumber: form.cardNumber,
                    securityCode: form.securityCode,
                    holder: form.holder,
                    expirationDate: this.$options.filters.credCardDate(form.expirationDate),
                    brand: this.provider
                  }
                }
              };
              fun = this.subscriptionPayment;
              if (this.changeMethodPayment) fun = this.changePaymentMethod;
              _context8.n = 1;
              return fun(dataSend);
            case 1:
              data = _context8.v;
              if (data) {
                this.resetFormCard();
                this.getSubscriptionDetail();
                // this.dataInvoice = result.invoice
              }
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function cardPayment(_x3) {
        return _cardPayment.apply(this, arguments);
      }
      return cardPayment;
    }(),
    ticketPayment: function () {
      var _ticketPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(form) {
        var dataSend, fun, _yield$fun, success, result;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              dataSend = {
                planId: this.typePayment.id,
                farmId: this.itemPayment.id,
                paymentMethod: {
                  method: this.formOfPayment,
                  ticket: {
                    name: form.name,
                    identity: form.identity,
                    street: form.street,
                    number: form.number,
                    complement: form.complement,
                    zip: form.zip,
                    city: form.city,
                    state: form.state,
                    country: form.country,
                    district: form.district
                  }
                }
              };
              fun = this.subscriptionPayment;
              if (this.changeMethodPayment) fun = this.changePaymentMethod;
              _context9.n = 1;
              return fun(dataSend);
            case 1:
              _yield$fun = _context9.v;
              success = _yield$fun.success;
              result = _yield$fun.data;
              if (success) {
                this.resetFormTicket();
                this.getSubscriptionDetail();
                this.openTicketNewTab(result.invoice.linkTicket);
              }
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function ticketPayment(_x4) {
        return _ticketPayment.apply(this, arguments);
      }
      return ticketPayment;
    }(),
    cancelPlanMethod: function () {
      var _cancelPlanMethod = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var data, _yield$this$cancelPla, success;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              data = {
                planId: this.typePayment.id,
                farmId: this.itemPayment.id
              };
              _context0.n = 1;
              return this.cancelPlan(data);
            case 1:
              _yield$this$cancelPla = _context0.v;
              success = _yield$this$cancelPla.success;
              if (success) {
                this.goToBack();
              }
            case 2:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function cancelPlanMethod() {
        return _cancelPlanMethod.apply(this, arguments);
      }
      return cancelPlanMethod;
    }(),
    openTicketNewTab: function openTicketNewTab(link) {
      var win = window.open(link, '_blank');
      win.focus();
    },
    generateNewTicket: function () {
      var _generateNewTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var dataSend, data;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (!(this.lastPayment.status !== 'PAID')) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, this.$buefy.toast.open({
                message: 'Para gerar uma nova parcela o boleto anterior deve estar quitado!',
                position: 'is-top',
                type: 'is-danger'
              }));
            case 1:
              dataSend = {
                farmId: this.farm.id,
                subId: this.itemPayment.id,
                planId: this.itemPayment.plan.id
              };
              _context1.n = 2;
              return this.generateNewTicketInvoice(dataSend);
            case 2:
              data = _context1.v;
              if (data) {
                this.getSubscriptionDetail();
                this.openTicketNewTab(data.invoice.linkTicket);
              }
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function generateNewTicket() {
        return _generateNewTicket.apply(this, arguments);
      }
      return generateNewTicket;
    }(),
    openModal: function openModal(type) {
      var modal = type === _constants.TYPES_PAYMENTS.TICKET ? _ModalTicket.default : _ModalCredCard.default;
      this.$buefy.modal.open({
        parent: this,
        component: modal,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          itemPayment: this.itemPayment,
          formOfPayment: this.formOfPayment,
          typePayment: this.typePayment,
          discount: this.discount,
          calculateForm: this.calculateValuePerHectare
        }
      });
    }
  })
};